import HomeBanner from './HomeBanner.jsx';
import HighlightPromotionContainer from './HighlightPromotionContainer.jsx';
import FavoriteCategoryContainer from './FavoriteCategoryContainer.jsx';
import HighlightProductByCategoryContainer from './HighlightProductByCategoryContainer.jsx';
import TradeNewsContainer from './TradeNewsContainer.jsx';
import EasyNeedOfferContainer from './EasyNeedOfferContainer.jsx';
import NeedOffersByCategoryContainer from './NeedOffersByCategoryContainer.jsx';
import SupportInfoContainer from './SupportInfoContainer.jsx';
import NewsLetterRegister from './NewsLetterRegister.jsx';
import HighlightNeedOfferTab from './HighlightNeedOfferTab.jsx';
import TopBusinessTab from './TopBusinessTab.jsx';
import TopProductTab from './TopProductTab.jsx';
import HotProducts from './HotProducts.jsx';
import BackgroundPage from './BackgroundPage.jsx';
import ListCategoryInFair from './ListCategoryInFair.jsx'
import AdsContainer from './AdsContainer.jsx'

export {
  HomeBanner,
  HighlightPromotionContainer,
  FavoriteCategoryContainer,
  HighlightProductByCategoryContainer,
  TradeNewsContainer,
  EasyNeedOfferContainer,
  NeedOffersByCategoryContainer,
  SupportInfoContainer,
  NewsLetterRegister,
  HighlightNeedOfferTab,
  TopBusinessTab,
  TopProductTab,
  HotProducts,
  BackgroundPage,
  ListCategoryInFair,
  AdsContainer
}



// WEBPACK FOOTER //
// ./components/home/sub-view/index.js